import styles from "./ArrowIcon.module.scss";
import classnames from "classnames";
import type { ArrowProps } from "./interface";

const ArrowIcon = (props: ArrowProps) => {
  const { color = "black", direction, disabled, onClick, className } = props;

  return (
    <div className={classnames(styles.arrow, disabled && styles.disabled, className)} style={{ color: color }} onClick={onClick}>
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="currentColor" />
        {direction === "left" ? (
          <path d="M22 14L16 20L22 26" stroke="currentColor" strokeWidth="2" />
        ) : (
          <path d="M18 26L24 20L18 14" stroke="currentColor" strokeWidth="2" />
        )}
      </svg>
    </div>
  );
};

export default ArrowIcon;
